import Token from '@/utils/Token';

export default {
    parseCountResponse(response) {
        const body = response?.data ?? {};
        const data = body.data ?? body;

        return Number(data.nao_lidas ?? data.count ?? data.total ?? 0);
    },

    parseListResponse(response) {
        const body = response?.data ?? {};
        const data = body.data ?? body;

        if (Array.isArray(data)) {
            return data;
        }

        if (Array.isArray(data.items)) {
            return data.items;
        }

        return [];
    },

    extractErrorMessage(error) {
        const err = error?.response?.data;
        if (err?.msg) {
            return err.msg;
        }
        if (err?.message) {
            return err.message;
        }
        if (error?.message) {
            return error.message;
        }
        return 'Ocorreu um erro inesperado.';
    },

    count() {
        return axios.get('/api/notificacao/count', Token.getHeader());
    },

    list(params = '') {
        if (params) {
            params = `?${params}`;
        }
        return axios.get(`/api/notificacao/list${params}`, Token.getHeader());
    },

    marcarLida(id) {
        return axios.post(`/api/notificacao/${id}/ler`, {}, Token.getHeader());
    },

    marcarTodas() {
        return axios.post('/api/notificacao/ler-todas', {}, Token.getHeader());
    },
};
